import { Controller } from '@hotwired/stimulus';

// Toggles the mobile sticky invest CTA: hidden while the in-page invest button is in view,
// shown otherwise. Degrades gracefully — without both targets the observer never runs and
// the sticky bar (if any) stays visible.
export default class extends Controller {
  static targets = ['cta', 'bar'];

  connect() {
    if (!this.hasCtaTarget || !this.hasBarTarget) return;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.barTarget.classList.toggle('d-none', entry.isIntersecting);
      });
    });
    this.observer.observe(this.ctaTarget);
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }
}
